import clsx from "clsx"
import Link from "next/link"
import React, { useContext } from "react"

import LinkOut from "../../../../../public/icons/link-out.svg"
import PageThemeContext from "../../page-theme/PageThemeContext"

interface ISubmenuLinkProps {
  linkTo: string
  heading: string
  subheading: string
  outbound?: boolean
}

const SubmenuLink: React.FC<ISubmenuLinkProps> = ({
  linkTo,
  heading,
  subheading,
  outbound,
}) => {
  const pageThemeContext = useContext(PageThemeContext)
  const headingColorClass = pageThemeContext.pageTheme.dark
    ? "text-gray-2.5"
    : "text-gray-90"
  const subHeadingColorClass = pageThemeContext.pageTheme.dark
    ? "text-gray-40"
    : "text-gray-60"
  return (
    <Link href={linkTo} className="md:mb-8 md:block header-link">
      <div
        className={clsx("mb-4 text-base md:mb-0 md:text-lg", headingColorClass)}
      >
        {heading}
        {outbound && (
          <LinkOut
            alt="Link Out Icon"
            className="ml-2 mb-1 inline stroke-blue-50"
          />
        )}
      </div>
      {subheading && (
        <div
          className={clsx("hidden text-base md:block", subHeadingColorClass)}
        >
          {subheading}
        </div>
      )}
    </Link>
  )
}

export default SubmenuLink
